// extracted by mini-css-extract-plugin
export default {"modal80w":"ModalHelpDialog_modal80w__w3-qY","modal50w":"ModalHelpDialog_modal50w__hMjBz"};